// extracted by mini-css-extract-plugin
export default {"pl1":"Spinner_pl1__Q8Yih","pl1g":"Spinner_pl1g__dIXAg","pl1rect":"Spinner_pl1rect__h6Jss","pl1a":"Spinner_pl1a__CqLZl","pl1b":"Spinner_pl1b__BNnGg","pl1c":"Spinner_pl1c__p89UH"};